import { expiredAuthMessage } from "@smartrr/shared/constants";

import { CustomerAsyncDispatch } from "@customer-app/state/typedCustomerRedux";

export const customerAsyncDispatch: CustomerAsyncDispatch = async function customerAsyncDispatch(
  promise,
  onLoading,
  onError,
  onSuccess
) {
  // kick this off before dispatch to get it going ASAP
  await onLoading();

  try {
    const res = await promise; // not handling failures because that should be impossible per
    switch (res.type) {
      case "error": {
        if (typeof document !== "undefined" && res.message === expiredAuthMessage) {
          document.location.reload();
        }

        return onError({
          status: res.status,
          message: res.message,
        });
      }
      case "success": {
        return onSuccess(res.body);
      }
    }
  } catch (error) {
    return onError({
      status: 400,
      message: `unhandled error: ${error?.message || ""}`,
    });
  }
};
